import { DatePipe } from '@angular/common';
import { ViewChild } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationDialogService } from '../components/confirmation-dialog/confirmation-dialog.service';
import { AppdataService } from '../services/services/appdata.service';
import { LoginserviceService } from '../services/services/loginservice.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {


  isadd: boolean = false;
  isedit: boolean = false;
  isdelete: boolean = false;
  isview: boolean = false;
  isprint: boolean = false;
  isexport: boolean = false;
  isfilter: boolean = false;

  isloading: boolean = false;

  isprivilage: boolean = false;

  fromdate: any = new Date();
  todate: any = new Date();

  formname: string = "Allowance"

  empcount: any = 0;
  docexpiry: any = 0;
  approvalcount: any = 0;

  approvalsColl: any = [];
  birthdayColl: any = [];
  paymentlistColl: any = [];
  otherrequestColl: any = [];

  dateCustomClasses: DatepickerDateCustomClasses[];



  constructor(private appService: AppdataService, private loginService: LoginserviceService, public router: Router, private route: ActivatedRoute,
    private confirmationDialogService: ConfirmationDialogService, private productFindService: NgbModal, private toastr: ToastrService,
    private datePipe: DatePipe) {

    this.fnServiceChanges();

    this.dateCustomClasses = [
      { date: new Date(), classes: ['bg-warning'] },
    ];

  }

  //Company Check
  fnServiceChanges() {
    this.loginService.serviceAuthChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        this.fnCheckPrivilage();
        if (this.isview) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }

      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    });
  }
  //Init
  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        this.fnCheckPrivilage();
        if (this.isview) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    // this.fngetDashboard();
    // this.fngetApprovalsListview('PENDING');
    // this.fngetPaymentListview();
    // this.fngetOtherRequest();
  }


  fnCheckPrivilage() {

    this.isadd = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE');
    this.isedit = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER');
    this.isdelete = this.loginService.fnCheckUserRoleAction(this.formname, 'DELETE');
    this.isview = this.loginService.fnCheckUserRoleAction(this.formname, 'VIEW');
    this.isprint = this.loginService.fnCheckUserRoleAction(this.formname, 'PRINT');
    this.isexport = this.loginService.fnCheckUserRoleAction(this.formname, 'EXPORT');


  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }

  //Get
  fngetPaymentListview() {
 
    var data = {
      'formname': '',
      'companyid': this.loginService.fnGetCompanyId(),
      'status': '',
      'empid':0, 
      'branchid': 0,
      'fromdate':this.fnFormatDatetime(this.fromdate),
      'todate':this.fnFormatDatetime(this.todate), 
      'modifiedby': this.loginService.fnGetModUserId(),
    }
    
    this.appService.getPaymentListviewReport(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.paymentlistColl = res.json().result;
        console.log(this.paymentlistColl)
         

          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
  //Get 
  fngetOtherRequest() {
   
    var data = {
      'otherrequestid': 0,
      'companyid': this.loginService.fnGetCompanyId()
    }
    this.appService.fngetOtherRequest(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.fnHideProgress();

            this.otherrequestColl = res.json().result;
        
          }
          else {
            this.fnHideProgress();

            this.loginService.fnAPIError(res.json())
          }

        },
        (err) => {
          this.fnHideProgress();

          this.toastr.error('Error', err);
        })
  }

  //Get
  fngetApprovalsListview(filterstatus) {
    var data = {
      'formname': '',
      'status': filterstatus,
      'modifiedby': this.loginService.fnGetModUserId(),
    }

    this.appService.getApprovalsListview(data)
      .subscribe(
        (res) => {
       
          if (res.json().status === 200) {
            this.approvalsColl = res.json().result;

          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  fngetDashboard() {

    var data = {
      'companyid': this.loginService.fnGetCompanyId(),
      'fromdate': this.fnFormatDatetime(this.fromdate),
      'todate': this.fnFormatDatetime(this.todate),
      'sectionname': '',
      'modifiedby': this.loginService.fnGetModUserId(),
    }
    this.appService.getDashboard(data)
      .subscribe(
        (res) => {
         
          if (res.json().status === 200) {
            var _result = res.json().result;

            this.empcount = _result[0][0].empcount;
            this.docexpiry = _result[0][0].totaldocumentexpiry;
            this.approvalcount = _result[0][0].totalapprovalcount;

            this.birthdayColl = _result[1]
          }

          else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  fnMomentDateTimeFormatter(params) {
    if (params.value) {
      return moment(params.value).format('DD-MM-YYYY hh:mm a');//  
    }
    else {
      return '';
    }

  }
  fnFormatDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        return this.datePipe.transform(dt, "yyyy-MM-dd")
      }

    } else {
      return null
    }

  }
  fnConvertDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        var dateParts = dt.split("-");
        var sdate = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2] + 1);
        sdate.setMinutes(sdate.getMinutes() + sdate.getTimezoneOffset());
        return sdate;
      }

    } else {
      return null
    }

  }
  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }

  private fnShowProgress() {
    // this.showProgress = true;
  }
  private fnHideProgress() {
    //this.showProgress = false;
  }


  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }








}
